module.exports = __webpack_public_path__ + "img/4.343e8f79.jpg";